import React from "react";
import YouTube, { YouTubeProps } from "react-youtube";

type Props = YouTubeProps;

const LazyYouTube: React.FC<Props> = (props) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setLoaded(true);
      window.removeEventListener("scroll", handleScroll);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!loaded) {
    return null;
  }

  return <YouTube {...props} />;
};

export default LazyYouTube;
